// extracted by css-extract-rspack-plugin
export default {"cls1":"ChatInterface-cls1_sG6","cls2":"ChatInterface-cls2_ahp ChatInterface-cls1_sG6"};